import * as moment from 'moment';

import { Component, OnInit } from '@angular/core';

import { KEYS } from '../../../../../core/service/constants/service.constants';
import { StorageSessionService } from '../../../../../core/storage/services/storage.session.service';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../../core/utility/services/utility.service';
import { PERMISSION } from '../../../../analytics-core/interfaces/permission.interface';
import { AnalyticsCoreURLService } from '../../../../analytics-core/services/analytics-core.url.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../../analytics/services/analytics.service';
import { WidgetCore } from '../../../../widget-library/interfaces/widget.core.interface';

@Component({
	selector: 'app-breadcrumb-navigator',
	styleUrls: ['./breadcrumb-navigator.component.css'],
	templateUrl: './breadcrumb-navigator.component.html'
})
export class BreadcrumbNavigatorComponent implements OnInit, WidgetCore {
	public key: string;

	public navigatorEnabled = false;
	public hasRenewalStrategy = false;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: false,
		position: 'top',
		scale: 'big'
	};
	private advertisers: any[];
	private campaigns: any[];

	constructor(
		private storageSessionService: StorageSessionService,
		private analyticsCoreURLService: AnalyticsCoreURLService,
		private analyticsDataModel: AnalyticsDataModel,
		private analyticsService: AnalyticsService
	) {
		EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			if (response) {
				this.toggleNavigator();
			}
		});
	}

	ngOnInit(): void {
		const permissions = this.analyticsDataModel.setupData.userPermissions;
		this.hasRenewalStrategy = !UtilityService.isUndefinedOrNull(permissions[PERMISSION[PERMISSION.hasRenewalStrategy]])
			? permissions[PERMISSION[PERMISSION.hasRenewalStrategy]]
			: false;
		this.toggleNavigator();
	}

	requestData(): void {
		if (this.key !== '' && this.hasRenewalStrategy) {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				if (response.success) {
					this.processResponseData(response);
				}
			});
		}
	}

	processResponseData(responseData: any): void {
		const data = responseData.data.length ? responseData.data[0] : {};
		this.navigatorEnabled = UtilityService.toTrueOrFalse(data.status);
	}

	/**
	 * Enable Navigator Icon only if Advertisers and Campaigns count is 1 and Campaign should be a Display Campaign.
	 * Renewal Strategy currently works with 1 Advertiser and 1 Display Campaign.
	 */
	toggleNavigator(): void {
		this.advertisers = this.analyticsDataModel.selectedAdvertisers;
		this.campaigns = this.analyticsDataModel.selectedCampaigns;
		let makeCall = false;
		if (this.advertisers.length === 1 && this.campaigns.length === 1) {
			makeCall = this.campaigns[0].isDisplay;
		}
		if (makeCall) {
			this.requestData();
		} else {
			this.navigatorEnabled = makeCall;
		}
	}

	navigateToPlatform(): void {
		if (this.navigatorEnabled) {
			const data = this.getDataForNavigation();
			this.openWindowWithPost(data);
		}
	}

	getDataForNavigation(): object {
		const authToken = this.storageSessionService.getToken(KEYS.STORAGE_TOKEN_ID)[KEYS.COOKIE_TOKEN_ID];
		const domain = this.analyticsCoreURLService.domainName;
		const advertisers: any[] = this.analyticsDataModel.selectedAdvertisers;
		const campaigns: any[] = this.analyticsDataModel.selectedCampaigns;
		const advertiserId = advertisers.length > 0 ? advertisers[0].id : undefined;
		const campaignId = campaigns.length > 0 ? campaigns[0].id : undefined;
		const startDate = moment(this.analyticsDataModel.startDate).format('YYYY-MM-DD');
		const endDate = moment(this.analyticsDataModel.endDate).format('YYYY-MM-DD');
		const data = {
			action: 'create_proposal',
			advertiser_id: advertiserId,
			auth_token: authToken,
			campaign_id: campaignId,
			domain,
			end_date: endDate,
			landing_page: undefined,
			start_date: startDate
		};
		return data;
	}

	/**
	 * Grabs required data for single sign on and make a post call in a window to pass data.
	 *
	 * @param data
	 */
	openWindowWithPost(data: any): void {
		const form = document.createElement('form');
		form.target = '_blank';
		form.method = 'POST';
		form.action = this.analyticsCoreURLService.serviceURL + '/analytics_module/redirect_to_platform/';
		form.style.display = 'none';

		for (const key of data) {
			if (key) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = data[key];
				form.appendChild(input);
			}
		}
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	}
}
